<template>
    <div class="main">
        <c-panel title="Devolução de exemplar" titleIcon="fas fa-undo-alt">
            <devolucao></devolucao>
        </c-panel>
    </div>
</template>
<script>
import devolucao from "./devolucao"

export default {
    components:{ devolucao }
}
</script>
